import styled from 'styled-components'

export const TestiMonailItem = styled.div`
margin-bottom: 20px;
position: relative;
background-color: white;
padding: 20px;
border-radius: 5px;
border: 1px solid #e5e5e5;
img{
    width: 60px !important;
    height: 60px!important;
    border-radius: 50%;
    position: absolute;
    top: -39px;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
    left: 50%;
    transform: translate(-50%, -0px);
}
@media (max-width:593px){
    margin-bottom: 53px;
}
`;

export const TestMonailItemText = styled.div`
text-align: center;
margin: 14px 0px;
h6{
    font-weight: 600;
}
p:nth-child(2){
    font-size: 12px;
    color: #9d9d9d;
    margin-bottom: 6px; 
}
p:nth-child(3){
    font-size: 12px;
    color: #5c5c5c;
    margin-bottom: 6px; 
}
`;

export const TestMonailItemRating = styled.div`
text-align: center;
i{
    font-size: 11px;
    color: #ffb400;
    margin: 0 3px;
}
`;
